import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_9,
  OPERATOR_TYPES_10,
} from './operators';

import {
  commonFilters,
  commonFiltersAndTeamAgent,
  teamAgentFilters,
  opportunityFilters,
  opportunityActivityFilters,
} from './constants/filters';

import {
  standardActions,
  conversationOpenedActions,
  opportunityActions,
} from './constants/actions';

import { AUTOMATION_RULE_EVENTS } from './constants/events';
import { AUTOMATION_ACTION_TYPES } from './constants/actionTypes';

export { AUTOMATION_RULE_EVENTS, AUTOMATION_ACTION_TYPES };

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'Message Type',
        attributeI18nKey: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'internal_note',
        name: 'Internal Note',
        attributeI18nKey: 'INTERNAL_NOTE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_9,
      },
      {
        key: 'content',
        name: 'Message Content',
        attributeI18nKey: 'MESSAGE_CONTAINS',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'is_template',
        name: 'Is Template',
        attributeI18nKey: 'IS_TEMPLATE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  conversation_created: {
    conditions: [
      {
        key: 'sent_campaign_name',
        name: 'Sent Campaign Name',
        attributeI18nKey: 'SENT_CAMPAIGN_NAME',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_10,
      },
    ].concat(commonFilters),
    actions: standardActions,
  },
  conversation_updated: {
    conditions: [].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  conversation_opened: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: conversationOpenedActions,
  },
  conversation_status_changed: {
    conditions: [].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  conversation_tag_updated: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'labels:before',
        name: 'Labels before update',
        attributeI18nKey: 'LABELS_BEFORE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_10,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  conversation_team_updated: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'team_id:before',
        name: 'Team before update',
        attributeI18nKey: 'TEAM_NAME_BEFORE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_10,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  conversation_agent_updated: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id:before',
        name: 'Assignee before update',
        attributeI18nKey: 'ASSIGNEE_NAME_BEFORE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_10,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  conversation_priority_updated: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  calllog_initiated: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  calllog_completed: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  calllog_failed: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  calllog_attended: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
    ].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  calllog_accept_return: {
    conditions: [
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      ...teamAgentFilters,
    ].concat(commonFilters),
    actions: standardActions,
  },
  event_log: {
    conditions: [].concat(commonFiltersAndTeamAgent),
    actions: standardActions,
  },
  opportunity_created: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_status_changed: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_stage_changed: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_value_changed: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_owner_changed: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_overdue: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_temperature_changed: {
    conditions: [].concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_activity_created: {
    conditions: opportunityActivityFilters.concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_activity_completed: {
    conditions: opportunityActivityFilters.concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_activity_rescheduled: {
    conditions: opportunityActivityFilters.concat(opportunityFilters),
    actions: opportunityActions,
  },
  opportunity_activity_canceled: {
    conditions: opportunityActivityFilters.concat(opportunityFilters),
    actions: opportunityActions,
  },
};
